import React from "react";
import { useNavigate } from "react-router-dom";
import { logout } from "../api/auth";
import logo from "../assets/ft-logo.svg";
import NotificationBell from "./NotificationBell";

function Header({ user }) {
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
  };

  return (
    <header className="bg-gradient-to-r from-emerald-50/80 via-white to-blue-50/80 backdrop-blur-lg shadow-lg border-b border-emerald-200/50 sticky top-0 z-40 w-full">
      <div className="w-full px-6 lg:px-8 max-w-full">
        <div className="flex justify-between items-center h-20 w-full">
          <div className="flex items-center gap-4">
            <img
              src={logo}
              alt="FastTrackr Logo"
              className="h-10 w-10"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'block';
              }}
            />
            <div style={{display: 'none'}} className="text-xl font-bold text-black">FT</div>
            <div>
              <div className="text-xl font-bold text-black">
                FastTrackr AI
              </div>
            </div>
          </div>
          
          <div className="flex items-center gap-4">
            <NotificationBell />
            <div className="hidden sm:flex items-center gap-3 px-5 py-2.5 bg-gradient-to-r from-white to-gray-50/50 rounded-2xl border border-gray-200/50 shadow-sm hover:shadow-md transition-all">
              <div className="w-10 h-10 bg-gradient-to-br from-emerald-500 via-emerald-600 to-blue-600 rounded-xl flex items-center justify-center text-white text-sm font-bold shadow-md">
                {user?.email?.charAt(0).toUpperCase() || 'U'}
              </div>
              <div className="text-sm">
                <div className="font-bold text-gray-900">{user?.first_name} {user?.last_name}</div>
                <div className="text-xs text-gray-600 font-medium">{user?.email}</div>
              </div>
            </div>
            <button
              onClick={handleLogout}
              className="px-5 py-2.5 text-sm font-semibold text-gray-700 bg-white hover:bg-gray-50 rounded-xl border border-gray-200 hover:border-gray-300 shadow-sm hover:shadow-md transition-all duration-200"
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
